import "./FormGuidelines.css";

export default function FormGuidelines({ className = "" }) {
  return (
    <div className={`form-guidelines${className ? ` ${className}` : ""}`} role="note">
      <p>
        <span className="form-guidelines-req">*</span> Required fields cannot be left empty.
      </p>
    </div>
  );
}